import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vSelect from 'vue-select'
import datePicker from 'vue-bootstrap-datetimepicker'
import VueTheMask from 'vue-the-mask';
import VueClipboard from 'vue-clipboard2'
import MaxLengthsConstants from '@/constants/maxLengths';
import V2Datepicker from 'v2-datepicker';
import VueHtml2Canvas from 'vue-html2canvas';
import 'v2-datepicker/lib/index.css';   // v2 need to improt css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import * as Sentry from '@sentry/vue';
import { sentryConfig } from '@/util/sentry';
import 'regenerator-runtime/runtime' // async await

import '@/util/gapmoment';

import './assets/scss/style.scss';

import './util';
import alert from "@/util/alert";
import apiInViewTemplate from "@/util/apiInViewTemplate";
import excel from "exceljs";
import axios from "axios";

Vue.use(V2Datepicker);
Vue.use(excel);

Vue.config.productionTip = false;
Vue.use(VueTheMask);
Vue.use(BootstrapVue);
Vue.use(datePicker);
Vue.use(VueClipboard);
Vue.use(VueHtml2Canvas);
Vue.component('v-select', vSelect);
MaxLengthsConstants.install(Vue);
apiInViewTemplate.install(Vue);

if (process.env.NODE_ENV !== 'local') {
  Sentry.init(sentryConfig);
}

if (window.Kakao) {
  Kakao.init(process.env.VUE_APP_CAPRI_JAVASCRIPT_KEY);
  console.log(Kakao.isInitialized());
}

const vue = new Vue({
                      router,
                      store,
                      render: h => h(App)
                    }).$mount('#app');

alert.install(vue);
